require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-you-re-invited-code-fellows-open-house.json") })
        }
      }, "path---blog-you-re-invited-code-fellows-open-house");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-you-re-invited-code-fellows-open-house!./.cache/json/blog-you-re-invited-code-fellows-open-house.json
// module id = 1198
// module chunks = 231608221292675